import ASTBlock from "../ASTBlock";
import Blockly from 'blockly';

export default class Number extends ASTBlock {
    constructor(color) {
        super(color, "number")
        this.predefinedInputs = {}
        this.TOP_LEVEL = undefined
    }

    addToBlockly() {
        var json = {
            "message0": "%1",
            "args0": [{
                "type": "field_number",
                "name": "value"
            }],
            "output": "Number"
        }

        let that = this
        Blockly.Blocks[this.name] = {
            init: function() {
                this.jsonInit(json);
                this.setColour(that.color)
            }

        }
    }
}